export const ORDER_STATUS_COLUMN_COUNT = 6;

export const ORDER_COLUMN_GRID_SX = {
  display: 'grid',
  gridTemplateColumns: `repeat(${ORDER_STATUS_COLUMN_COUNT}, 1fr)`,
  gap: 2,
  width: '100%',
} as const;

export const ORDER_COLUMN_CELL_SX = {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  height: '100%',
} as const;
